












































































































































































































































































































import { Vue, Component, Prop, Watch, Inject } from "vue-property-decorator";
import { getEnumMap, isEmptyOrWhiteSpace } from "@/utils/Common";
import { API_BIS_PATENT_SINGLECATEGORY, API_BIS_PATENT_SINGLEINDEXING, API_BIS_PATENTTEXT_FULLTEXT, API_BIS_PATENTTEXT_LEGALNOTE } from "@/configs/Apis";
import { showConfirm, showSuccess, showWarning } from "@/utils/UI";

import DEmpty from "../base/DEmpty.vue";
import Ipc from "@/views/base/Ipc.vue";

@Component({ components: { DEmpty, Ipc } })
export default class PatentView extends Vue {
    @Prop({ required: true, default: () => ({}), type: Object })
    patent!: any;

    @Prop({ default: () => "", type: String })
    treeData!: string;

    staticTreeData: Array<any> = [];

    activeName = "info";

    fullText: any = {};
    legalNote: any = {};
    customfieldValues: any = {};

    @Inject()
    projectId!: string;

    created() {
      this.parsePatentData();
      if (!isEmptyOrWhiteSpace(this.treeData)) {
        this.staticTreeData = JSON.parse(this.treeData);
        this.staticTreeData.forEach(item => item.disabled = true);
      }
    }

    isEmptyContent(value: string) {
      return isEmptyOrWhiteSpace(value);
    }

    formatClaims(value: string) {
      return value.replace(/(\s|^)\d+[\.、，]/g, function (r: any) {
        return (r[0] == 1 ? "" : "<br/>") + "<span style='font-size:14px;font-weight:bold;color:crimson;'>" + r + "</span>&nbsp;&nbsp;";
      }).replace(/\n/g, "<br/>\n");
    }

    formatSpecification(value: string) {
      let val = "";
      if (this.patent.patentNo.indexOf("CN") == 0) {
        val = value.replace(/(所属技术领域|技术领域|发明内容|实用新型内容|背景技术|附图说明|具体实施方式|详细描述[\n:：]|\n附图[描简]述\n|\n背景\n|\n简要概述\n|\n概述\n)/g, function (r) {
          return "<br/><span style='color:crimson;'>" + r + "</span><br/>";
        });
      } else {
        val = value.replace(/(TECHNICAL FIELD|BACKGROUND OF THE INVENTION|SUMMARY OF THE INVENTION|DETAILED DESCRIPTION OF THE INVENTION)/g, function (r) {
          return "<br/><span style='color:crimson;font-weight:bold;'>" + r + "</span><br/>";
        });
      }
      return val.replace(/([\r\n]+|<br>)/g, "\n<br>");
    }

    parsePatentData() {
      const patentText = this.patent.patentText || {};
      this.fullText = {
        fullTextModifiedTime: patentText.fullTextModifiedTime,
        claims: patentText.claims,
        specification: patentText.specification
      };

      this.legalNote = {
        leagalNote: patentText.leagalNote,
        leagalNoteModifiedTime: patentText.leagalNoteModifiedTime
      };

      const fields: Array<any> = this.$store.getters["project/customfields"];
      const fieldData: any = {};
      if (fields && fields.length) {
        fields.forEach(field => {
          const cfield = field.fieldName.replace("_", "");
          if (field.fieldType === "TEXT") {
            fieldData[cfield] = this.patent.patentText ? (this.patent.patentText[cfield] || "") : "";
          } else {
            fieldData[cfield] = this.patent[cfield] || "";
          }
        });
      }
      this.customfieldValues = fieldData;

      this.setTreeChecked();
    }

    setTreeChecked() {
    //   const nodes: Array<any> = [];
    //   if (this.patent.patentCategoryList && this.patent.patentCategoryList.length) {
    //     nodes.push(...this.patent.patentCategoryList.map((item: any) => item.categoryId));
    //   }
    //   this.$nextTick(() => (this.$refs.tree as any).setCheckedKeys(nodes));
    }

    getPatentTypeLabel(value: string) {
      const map = getEnumMap(this.$store.getters["enums/getEnumsByKey"]("PatentType"));
      return map.get(value);
    }

    updateFullText() {
      showConfirm("是否更新代码化全文").then(() => {
        this.$http.put({ url: API_BIS_PATENTTEXT_FULLTEXT, path: { projectId: this.projectId, patentId: this.patent.id } }, {}).then((data) => {
          this.fullText = data || {};
          Object.assign(this.patent.patentText, data);
          showSuccess("更新成功");
        });
      });
    }

    updateLegalNote() {
      showConfirm("是否更新法律状态").then(() => {
        this.$http.put({ url: API_BIS_PATENTTEXT_LEGALNOTE, path: { projectId: this.projectId, patentId: this.patent.id } }, {}).then((data) => {
          this.legalNote = data;
          Object.assign(this.patent.patentText, data);
          showSuccess("更新成功");
        });
      });
    }

    saveIndexing() {
      const customfields: Array<any> = this.$store.state.project.metadata;
      if (!customfields || !customfields.length) {
        showWarning("没有需要保存的自定义标引字段");
        return;
      }
      showConfirm("是否保存自定义标引的值").then(() => {
        const postedData: Array<string[]> = [];

        customfields.forEach(field => {
          const fieldName = field.fieldName.replace("_", "");
          if (this.patent.hasOwnProperty(fieldName)) {
            postedData.push([fieldName, this.customfieldValues[fieldName]]);
          }
        });

        this.$http.post({ url: API_BIS_PATENT_SINGLEINDEXING, path: { projectId: this.projectId } }, { patentId: this.patent.id, indexingInfo: postedData }).then(() => {
          Object.assign(this.patent, this.customfieldValues);
          showSuccess("保存成功");
          this.$emit("refresh-tree");
        });
      });
    }

    saveCategory() {
      if (!this.staticTreeData || !this.staticTreeData.length) {
        showWarning("没有自定义分类树，请先创建分类");
        return;
      }
      const tree = this.$refs.tree as any;
      const selectedNodes: Array<any> = tree.getCheckedNodes();
      if (!selectedNodes || !selectedNodes.length) {
        showWarning("请选择一个分类");
        return;
      }
      showConfirm("是否保存分类").then(() => {
        const postedData: Array<string[]> = [];
        postedData.push(...selectedNodes.map(node => node.id));
        this.$http.post({ url: API_BIS_PATENT_SINGLECATEGORY, path: { projectId: this.projectId } }, { patentId: this.patent.id, categoryIdList: postedData }).then(() => {
          showSuccess("保存成功");
          this.$emit("refresh-tree");
          if (!this.patent.hasOwnProperty("patentCategoryList")) {
            this.patent.patentCategoryList = [];
          }
          this.patent.patentCategoryList.length = 0;
          this.patent.patentCategoryList.push(...selectedNodes.map(node => ({ categoryId: node.id })));
        });
      });
    }

    @Watch("patent")
    onPatentChange() {
      this.fullText = {};
      this.legalNote = {};
      this.parsePatentData();
      this.setTreeChecked();
    }

    openCnipaLink() {
      if (isEmptyOrWhiteSpace(this.patent.pubNo)) {
        showWarning("目前只支持查看已公开专利");
        return;
      }
      window.open("http://epub.sipo.gov.cn/tdcdesc.action?strWhere=" + this.patent.pubNo);
    }

    openEspacenetLink() {
      if (isEmptyOrWhiteSpace(this.patent.pubNo)) {
        showWarning("目前只支持查看已公开专利");
        return;
      }
      window.open("https://worldwide.espacenet.com/publicationDetails/biblio?CC=CN&NR=" + this.patent.pubNo.substring(2) + "&FT=D&locale=cn_EP");
    }
}
